import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: decodeURIComponent(m[1]) });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/home", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Try again.");
        nav("/", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center label-mono">Signing you in…</div>;
}
